import ClickOutside from './/directives/click-outside';
import Vue from 'vue';

window.navigation = new Vue({
    el: '#navigation',

    directives: { ClickOutside },

    data: {
        mobileMenuOpen: false,

        accountMenu: {
            visible: false,
            notificationsVisible: false,
        },

        messages: {
            visible: false,
            unreadCount: 0,
            interval: null,
        },

        notifications: [],
    },

    methods: {
        toggleAccountMenu() {
            this.messages.visible = false;
            this.accountMenu.visible = !this.accountMenu.visible;
        },

        hideAccountMenu() {
            this.accountMenu.visible = false
        },

        openMobileMenu() {
            this.mobileMenuOpen = true;
        },

        closeMobileMenu() {
            this.mobileMenuOpen = false;
        },

        toggleMobileMenu() {
            this.messages.visible = false;
            this.accountMenu.visible = false;
            this.mobileMenuOpen = !this.mobileMenuOpen;
        },

        logoutAndReturnBack() {
            axios.get('/logout').then(
                response => {
                    window.close();
                }
            );
        },
    } 

    
});